import React from 'react';
import { useSidebarState } from './useSidebarState';

export const SidebarContextProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const {
    isOpen,
    isMenu,
    isVisible,
    showSidebar,
    setSidebarMenu,
    setSidebarBack,
    openSidebar,
    hideSidebar,
    closeSidebar,
  } = useSidebarState();

  return (
    <SidebarContext.Provider
      value={{
        openSidebar,
        closeSidebar,
        showSidebar,
        hideSidebar,
        setSidebarBack,
        setSidebarMenu,
        isSidebarOpen: isOpen,
        isSidebarMenu: isMenu,
        isSidebarVisible: isVisible,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebarContext = () => React.useContext(SidebarContext);

export type Value = {
  openSidebar: () => void;
  closeSidebar: () => void;
  showSidebar: () => void;
  hideSidebar: () => void;
  setSidebarMenu: () => void;
  setSidebarBack: () => void;
  isSidebarOpen: boolean;
  isSidebarMenu: boolean;
  isSidebarVisible: boolean;
};

const outsideProviderErrorMsg = 'Sidebar context called outside Provider';

const defaultValue: Value = {
  hideSidebar: () => {
    throw new Error(outsideProviderErrorMsg);
  },
  showSidebar: () => {
    throw new Error(outsideProviderErrorMsg);
  },
  openSidebar: () => {
    throw new Error(outsideProviderErrorMsg);
  },
  setSidebarBack: () => {
    throw new Error(outsideProviderErrorMsg);
  },
  setSidebarMenu: () => {
    throw new Error(outsideProviderErrorMsg);
  },
  closeSidebar: () => {
    throw new Error(outsideProviderErrorMsg);
  },
  isSidebarOpen: false,
  isSidebarMenu: true,
  isSidebarVisible: true,
};

export const SidebarContext = React.createContext<Value>(defaultValue);
